import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * ZAPI Webhook Handler Page
 * This page receives webhook notifications from ZAPI when patients respond to WhatsApp reminders
 * 
 * According to ZAPI documentation (https://developer.z-api.io/webhooks/on-message-received):
 * - Webhook receives POST requests with message data
 * - Message format includes: phone, message text, timestamp, etc.
 * 
 * IMPORTANT: This route must be configured in ZAPI dashboard as the webhook URL
 * Example: https://your-domain.com/webhook-zapi
 */
const ZAPIWebhookHandler = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('ready');

  useEffect(() => {
    // This component should not be accessed directly by users
    // It's only for receiving webhook POST requests from ZAPI
    // If someone navigates here manually, redirect them
    const timer = setTimeout(() => {
      navigate('/schedule-dashboard');
    }, 10);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div></div>
  );
};

export default ZAPIWebhookHandler;